module.exports = __webpack_public_path__ + "static/ITCAvantGardeStd-Md-5ba0eab2cdad830c2ae97b3d7cea1e37.woff";